import { SPARK_RESOURCE_TYPES } from 'constants/common'
import { useQuery } from 'react-query'
import { fetchWrapper } from 'utils/fetchWrapper'
import { CACHE_AND_STALE_TIME } from 'constants/index'
import type { WelcomeGreetings } from 'types/WelcomeGreetings'

export const useWelcome = () => {
  const getWelcomeGreetings = () => {
    return fetchWrapper<WelcomeGreetings>({
      url: SPARK_RESOURCE_TYPES.WELCOME,
      method: 'Get',
    })
  }

  return useQuery('WelcomeGreetings', getWelcomeGreetings, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to Get welcome greetings: ${error.message}`)
      }
    },
    ...CACHE_AND_STALE_TIME,
  })
}
